<template>
  <div class="card">
    <div class="card-header">
      <div class="title bold">Logs</div>
    </div>
    <div class="card-body">
      <div class="row mb-3">
        <div class="col-md-4">
          <label>Usuário</label>
          <v-select
            v-model="filters.user_id"
            :options="users"
            :reduce="(user) => user.id"
            label="name"
            placeholder="Selecione um usuário"
            :clearable="true"
          ></v-select>
        </div>
        <div class="col-md-4">
          <label>Veículo</label>
          <v-select
            v-model="filters.vehicle_id"
            :options="vehicles"
            :reduce="(vehicle) => vehicle.id"
            label="name"
            placeholder="Selecione um veículo"
            :clearable="true"
          ></v-select>
        </div>
        <div class="col-md-4">
          <label>Intervalo Data/Hora (início / fim)</label>
          <div class="d-flex" style="gap:8px">
            <input class="form-control" type="datetime-local" v-model="filters.start_datetime" />
            <input class="form-control" type="datetime-local" v-model="filters.end_datetime" />
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-md-4">
          <label>Coordenadas (lat, lng)</label>
          <b-form-input v-model="latlngInput" type="text" placeholder="-23.5672247602954, -46.63966970657134"></b-form-input>
        </div>
        <div class="col-md-2">
          <label>Raio</label>
          <b-form-input v-model.number="radiusValue" type="number" min="0" placeholder="1000"></b-form-input>
        </div>
        <div class="col-md-2">
          <label>Unidade</label>
          <select class="form-control" v-model="radiusUnit">
            <option value="m">Metros</option>
            <option value="km">KM</option>
          </select>
        </div>
        <div class="col-md-4 d-flex align-items-end" style="gap:8px">
          <!-- Botão 'Buscar por Raio' removido: agora a busca por coordenadas é feita pelo botão 'Filtrar' -->
          <!-- <button class="btn btn-primary" @click="getNearbyLogs">Buscar por Raio</button> -->
          <!-- Botão 'Mostrar no Mapa' comentado por enquanto -->
          <!-- <button class="btn btn-secondary" :disabled="nearbyLogs.length===0" @click="openNearbyMap">Mostrar no Mapa ({{ nearbyLogs.length }})</button> -->
          <button class="btn btn-outline-secondary" v-if="nearbyFilterActive" @click="clearNearbyFilter">Limpar Busca</button>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-md-12 text-right">
          <b-button variant="secondary" @click="clearFilters" class="mr-2">Limpar Filtros</b-button>
          <b-button variant="primary" @click="applyFilters"> Filtrar </b-button>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-md-12">
          <div class="title">Total de Logs: {{ displayedTotal }}</div>
        </div>
      </div>

      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Usuário</th>
            <th scope="col">Veículo</th>
            <th scope="col">Logs</th>
            <th scope="col">Data/Hora</th>
            <th scope="col">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="log in displayedLogs" :key="log.id">
            <th scope="row">{{ log.id }}</th>
            <td>{{ log.user ? log.user.name : '' }}</td>
            <td>{{ log.vehicle ? log.vehicle.name : '' }}</td>
            <td>{{ log.logs }}</td>
            <td>{{ log.created_at_f }}</td>
            <td>
              <button class="btn btn-view" @click="showDetails(log)">Exibir JSON</button>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="col-md-6 mt-1 mx-auto d-flex justify-content-center align-items-center">
        <pagination
          :key="paginationKey + (nearbyFilterActive ? 1 : 0)"
          :records="nearbyFilterActive ? nearbyTotal : total"
          :options="options"
          :per-page="nearbyFilterActive ? nearbyPerPage : logsPerPage"
          @paginate="handlePaginate"
        ></pagination>
      </div>
    </div>

    <!-- Modal JSON small -->
    <b-modal v-model="showModal" title="Detalhes do JSON" size="lg">
      <pre>{{ selectedLogJson }}</pre>
      <b-button variant="primary" @click="verMapa(selectedLogJson)">Ver Mapa</b-button>
      <template #modal-footer>
        <b-button variant="secondary" @click="showModal = false">Cancel</b-button>
        <b-button variant="primary" @click="showModal = false">OK</b-button>
      </template>
    </b-modal>

    <!-- Modal Nearby Map -->
    <b-modal v-model="showNearbyMap" title="Logs na Área" size="xl">
      <div>
        <GmapMap
          :zoom="14"
          :center="mapCenterForNearby"
          style="width: 100%; height: 650px"
        >
          <GmapCircle
            v-if="circleCenter && circleRadius > 0"
            :center="circleCenter"
            :radius="circleRadius"
            :options="{ fillColor: '#4169e1', fillOpacity: 0.08, strokeColor: '#4169e1', strokeWeight: 2 }"
          />

          <GmapMarker
            v-if="circleCenter"
            :key="'center_marker'"
            :position="{ lat: parseFloat(circleCenter.lat), lng: parseFloat(circleCenter.lng) }"
            :icon="{ url: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png' }"
          />

          <GmapMarker
            v-for="veh in nearbyVehicles"
            :key="veh.logId || (veh.vehicle && veh.vehicle.id) || veh.ts || Math.random()"
            :position="{ lat: parseFloat(veh.lat), lng: parseFloat(veh.lng) }"
            @click="openNearbyInfo(veh)"
          />

          <GmapInfoWindow
            v-if="nearbyInfoPosition"
            :position="{ lat: nearbyInfoPosition.lat, lng: nearbyInfoPosition.lng }"
            :opened="nearbyInfoOpened"
            @closeclick="nearbyInfoOpened = false"
          >
            <div>
              <div><strong>Latitude:</strong> {{ nearbyInfoPosition.lat }}</div>
              <div><strong>Longitude:</strong> {{ nearbyInfoPosition.lng }}</div>
              <div><strong>Data/Hora:</strong> {{ nearbyInfoPosition.created_at_f || '-' }}</div>
              <div v-if="nearbyInfoLog && nearbyInfoLog.vehicle"><strong>Veículo:</strong> {{ nearbyInfoLog.vehicle.name }}</div>
            </div>
          </GmapInfoWindow>
        </GmapMap>

        <div class="mt-2">Encontrados: {{ nearbyLogs.length }}</div>

        <table class="table table-sm table-striped mt-2" v-if="nearbyLogs.length > 0">
          <thead>
            <tr>
              <th>#</th>
              <th>Usuário</th>
              <th>Veículo</th>
              <th>Distância (m)</th>
              <th>Data/Hora</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="log in nearbyLogs" :key="'near-'+log.id">
              <td>{{ log.id }}</td>
              <td>{{ log.user ? log.user.name : '' }}</td>
              <td>{{ log.vehicle ? log.vehicle.name : '' }}</td>
              <td>{{ log.__distance_m }}</td>
              <td>{{ log.created_at_f || '-' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>

    <!-- Modal Map for a single JSON item -->
    <b-modal v-model="showModalMap" title="Detalhes do JSON" size="xl">
      <div class="row">
        <div class="col-md-12">
          <div class="row centered">
            <div class="col-md-2">
              <div class="bold">Bateria do Dispositivo</div>
              <div>
                <i :class="batteryIcon(selectedLogJsonInfos.battery_info)" class="fa fa-3x"></i>
                <div>{{ selectedLogJsonInfos.battery_info }}</div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="bold">Versão do Android</div>
              <div>
                <i class="fab fa-android fa-3x"></i>
                <div>{{ selectedLogJsonInfos.device_version }}</div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="bold">Modelo do Dispositivo</div>
              <div>
                <i class="fas fa-mobile-alt fa-2x mb-1"></i>
                <div>{{ selectedLogJsonInfos.device_name }}</div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="bold">IP do Dispositivo</div>
              <div>
                <i class="fas fa-network-wired fa-2x mb-1"></i>
                <div>{{ selectedLogJsonInfos.device_ip }}</div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="bold">Versão APP</div>
              <div>
                <i class="fas fa-clock fa-2x mb-1"></i>
                <div>{{ selectedLogJsonInfos.version_app }}</div>
              </div>
            </div>
          </div>

          <div class="title">Posição de Tentativa</div>
          <GmapMap :zoom="19" :center="selectedLogJson" style="width: 100%; height: 650px">
            <GmapMarker :position="selectedLogJson" />
          </GmapMap>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { Pagination } from 'vue-pagination-2';
import vSelect from 'vue-select';
import { BFormInput, BButton } from 'bootstrap-vue';
import axios from 'axios';

export default {
  components: { Pagination, vSelect, BFormInput, BButton },
  data() {
    return {
      options: { texts: { count: 'Mostrando {from} de {to} até {count} de registros' }, chunk: 4, chunksNavigation: 'fixed' },
      total: 0,
      page: 1,
      logs_positions: [],
      showModal: false,
      showModalMap: false,
      showNearbyMap: false,
      selectedLogJson: {},
      selectedLogJsonInfos: {},
      paginationKey: 0,
      filters: { user_id: null, vehicle_id: null, start_datetime: null, end_datetime: null, date: null },
      circleCenter: null,
      circleRadius: 0,
      nearbyVehicles: [],
      users: [],
      vehicles: [],
      latInput: null,
      lngInput: null,
      latlngInput: null,
      radiusValue: 1000,
      radiusUnit: 'm',
      nearbyLogs: [],
      nearbyFilterActive: false,
      nearbyTotal: 0,
      nearbyPage: 1,
      nearbyPerPage: 15,
      logsPerPage: 15,
      // cache pages per filter snapshot to avoid re-fetching when paginating
      logsCache: {},
      loadingLogs: false,
      loadingNearby: false,
      prevLogs: [],
      prevNearbyLogs: [],
      logsRequestId: 0,
      nearbyRequestId: 0,
      nearbyInfoPosition: null,
      nearbyInfoLog: null,
      nearbyInfoOpened: false,
    };
  },
  computed: {
    displayedLogs() { return this.nearbyFilterActive ? this.nearbyLogs : this.logs_positions; },
    displayedTotal() { return this.nearbyFilterActive ? this.nearbyTotal : this.total; },
    mapCenterForNearby() {
      if (this.circleCenter && this.circleCenter.lat !== undefined) return { lat: parseFloat(this.circleCenter.lat), lng: parseFloat(this.circleCenter.lng) };
      if (this.nearbyVehicles && this.nearbyVehicles.length > 0) return { lat: parseFloat(this.nearbyVehicles[0].lat), lng: parseFloat(this.nearbyVehicles[0].lng) };
      return { lat: 0, lng: 0 };
    }
  },
  methods: {
    clearFilters() {
      this.filters = { user_id: null, vehicle_id: null, start_datetime: null, end_datetime: null, date: null };
      // clear cache when filters are reset
      this.logsCache = {};
      this.page = 1;
      this.paginationKey++;
      this.getLogs(1);
    },

    getUsers() { axios.get(this.$store.state.api + 'users?paginated=false').then(r => this.users = r.data.data || []).catch(() => {}); },
    getVehicles() { axios.get(this.$store.state.api + 'vehicles?paginated=false').then(r => this.vehicles = r.data.data || []).catch(() => {}); },

    batteryIcon(batteryLevel) {
      if (!batteryLevel || typeof batteryLevel !== 'string') return 'fa-battery-empty';
      let level = batteryLevel.replace('%', '');
      level = parseInt(level, 10);
      if (isNaN(level)) return 'fa-battery-empty';
      if (level > 80) return 'fa-battery-full color-success';
      if (level > 60) return 'fa-battery-three-quarters color-success';
      if (level > 40) return 'fa-battery-half color-warning';
      if (level > 20) return 'fa-battery-quarter color-warning';
      return 'fa-battery-empty color-danger';
    },

    showDetails(log) {
      this.selectedLogJson = { lat: parseFloat(log.lat), lng: parseFloat(log.long) };
      this.selectedLogJsonInfos = {
        battery_info: log.battery_info,
        device_ip: log.device_ip,
        device_name: log.device_name,
        device_version: log.device_version,
        version_app: log.version_app,
      };
      this.showModal = true;
    },

    verMapa(selected) {
      if (selected && selected.lat !== undefined && selected.lng !== undefined) {
        this.selectedLogJson = { lat: parseFloat(selected.lat), lng: parseFloat(selected.lng) };
      }
      this.showModal = false;
      this.showModalMap = true;
    },

    normalizeDateTime(val, isEnd = false) {
      if (!val || typeof val !== 'string') return val;
      let v = val.trim();
      v = v.replace('T', ' ');
      if (/^\d{4}-\d{2}-\d{2}$/.test(v)) return isEnd ? `${v} 23:59:59` : `${v} 00:00:00`;
      if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(v)) return isEnd ? `${v}:59` : `${v}:00`;
      return v;
    },

    getLogs(page) {
      const self = this;
      self.page = page || 1;

      // snapshot filters and normalize datetimes
      const filtersSnapshot = JSON.parse(JSON.stringify(self.filters || {}));
      if (filtersSnapshot.start_datetime) filtersSnapshot.start_datetime = self.normalizeDateTime(filtersSnapshot.start_datetime, false);
      if (filtersSnapshot.end_datetime) filtersSnapshot.end_datetime = self.normalizeDateTime(filtersSnapshot.end_datetime, true);

      // concurrency id
      self.logsRequestId = (self.logsRequestId || 0) + 1;
      const thisRequestId = self.logsRequestId;

      // cache key based on current filters snapshot
      const cacheKey = JSON.stringify(filtersSnapshot || {});
      if (!self.logsCache[cacheKey]) {
        self.logsCache[cacheKey] = { pages: {}, total: 0, per_page: self.logsPerPage };
      }
      const cache = self.logsCache[cacheKey];

      // if requested page already cached, use it
      if (cache.pages[self.page]) {
        const cachedRows = cache.pages[self.page];
        self.logs_positions = cachedRows;
        self.total = cache.total || cachedRows.length;
        self.logsPerPage = cache.per_page || self.logsPerPage;
        // background prefetch next page if available
        const totalPagesCached = Math.max(1, Math.ceil((cache.total || 0) / (cache.per_page || self.logsPerPage)));
        const nextPageCached = (self.page || 1) + 1;
        if (nextPageCached <= totalPagesCached && !cache.pages[nextPageCached]) {
          const prefetchPayload = { ...filtersSnapshot, page: nextPageCached, per_page: cache.per_page || self.logsPerPage };
          axios.post(self.$store.state.api + 'logs_positions?page=' + nextPageCached, prefetchPayload)
            .then(prefRes => {
              const prefData = prefRes.data || {};
              const prefRows = prefData.data || [];
              if (!cache.pages[nextPageCached]) cache.pages[nextPageCached] = prefRows;
              cache.total = prefData.total || cache.total;
              cache.per_page = prefData.per_page || cache.per_page;
            })
            .catch(() => {});
        }
        return;
      }

      const api = self.$store.state.api + 'logs_positions?page=' + self.page;
      self.prevLogs = Array.isArray(self.logs_positions) ? self.logs_positions.slice() : [];
      self.loadingLogs = true;
      this.$loading && this.$loading(true);

      const payload = { ...filtersSnapshot, page: self.page, per_page: self.logsPerPage };

      axios.post(api, payload)
        .then((response) => {
          if (thisRequestId !== self.logsRequestId) return; // stale
          const data = response.data || {};
          const rows = data.data || [];
          // store in cache
          cache.pages[self.page] = rows;
          cache.total = data.total || rows.length;
          cache.per_page = data.per_page || cache.per_page || self.logsPerPage;

          self.logs_positions = rows;
          self.total = cache.total;
          self.logsPerPage = cache.per_page;

          this.$loading && this.$loading(false);
          self.loadingLogs = false;

          // prefetch next page in background if exists and not cached
          const totalPages = Math.max(1, Math.ceil((cache.total || 0) / cache.per_page));
          const nextPage = (self.page || 1) + 1;
          if (nextPage <= totalPages && !cache.pages[nextPage]) {
            const prefetchPayload = { ...filtersSnapshot, page: nextPage, per_page: cache.per_page };
            axios.post(self.$store.state.api + 'logs_positions?page=' + nextPage, prefetchPayload)
              .then((prefRes) => {
                const prefData = prefRes.data || {};
                const prefRows = prefData.data || [];
                // only store if not already cached (race-safe)
                if (!cache.pages[nextPage]) cache.pages[nextPage] = prefRows;
                // update total/per_page if provided
                cache.total = prefData.total || cache.total;
                cache.per_page = prefData.per_page || cache.per_page;
              })
              .catch(() => { /* ignore prefetch errors */ });
          }
        })
        .catch((error) => {
          if (thisRequestId !== self.logsRequestId) return;
          if (self.prevLogs && self.prevLogs.length > 0) self.logs_positions = self.prevLogs;
          this.$message && this.$message(null, (error.response && error.response.data) || error, 'error');
          this.$loading && this.$loading(false);
          self.loadingLogs = false;
        });
    },

    getNearbyLogs(page) {
      const self = this;
      const isFreshSearch = arguments.length === 0;
      let baseLat = null;
      let baseLng = null;
      if (self.latlngInput && typeof self.latlngInput === 'string') {
        const parts = self.latlngInput.replace(/[()]/g, '').split(',').map(p => p.trim()).filter(Boolean);
        if (parts.length >= 2) { baseLat = parseFloat(parts[0]); baseLng = parseFloat(parts[1]); }
      }
      if ((baseLat === null || isNaN(baseLat)) && self.latInput !== null) baseLat = parseFloat(self.latInput);
      if ((baseLng === null || isNaN(baseLng)) && self.lngInput !== null) baseLng = parseFloat(self.lngInput);
      if (baseLat === null || baseLng === null || isNaN(baseLat) || isNaN(baseLng)) {
        this.$message && this.$message(null, 'Informe coordenadas válidas (lat, lng)', 'warning');
        return;
      }

      let radiusMeters = Number(self.radiusValue) || 0;
      if (self.radiusUnit === 'km') radiusMeters = radiusMeters * 1000;

      const api = self.$store.state.api + 'logs_positions/nearby';
      const p = page || 1;
      const payload = { lat: baseLat, lng: baseLng, radius_m: radiusMeters, filters: self.filters, page: p, per_page: self.nearbyPerPage };

      self.$loading && self.$loading(true);
      axios.post(api, payload)
        .then((response) => {
          const data = response.data || {};
          if (data.logs && data.logs.data) {
            self.nearbyLogs = (data.logs.data || []).map(r => ({ ...r, __distance_m: r.distance_m }));
            self.nearbyTotal = data.logs.total || 0;
            self.nearbyPage = data.logs.current_page || p;
            self.nearbyPerPage = data.logs.per_page || self.nearbyPerPage;
          } else {
            self.nearbyLogs = (data.logs || []).map(r => ({ ...r, __distance_m: r.distance_m || r.distance_m }));
            self.nearbyTotal = self.nearbyLogs.length;
            self.nearbyPage = 1;
          }

          const rawVehicles = data.vehicles || [];
          const normalizedVehicles = rawVehicles.map(v => ({ ...v, lat: v.lat !== undefined && v.lat !== null ? parseFloat(v.lat) : null, lng: v.lng !== undefined && v.lng !== null ? parseFloat(v.lng) : null })).filter(v => !isNaN(v.lat) && !isNaN(v.lng));
          if (isFreshSearch) this.nearbyVehicles = normalizedVehicles; else if (normalizedVehicles.length > 0) this.nearbyVehicles = normalizedVehicles;

          if (isFreshSearch) this.paginationKey++;
          self.nearbyFilterActive = true;
          self.circleCenter = { lat: baseLat, lng: baseLng };
          self.circleRadius = radiusMeters;
          this.$loading && this.$loading(false);
        })
        .catch((error) => {
          console.error('Erro na busca por raio (backend):', error);
          this.$loading && this.$loading(false);
        });
    },

    openNearbyMap() {
      if (!this.nearbyLogs || this.nearbyLogs.length === 0) return;
      this.showNearbyMap = true;
    },

    openNearbyInfo(item) {
      this.nearbyInfoPosition = { lat: parseFloat(item.lat), lng: parseFloat(item.lng), created_at_f: item.created_at_f || null };
      this.nearbyInfoLog = item;
      this.nearbyInfoOpened = true;
    },

    clearNearbyFilter() {
      this.nearbyFilterActive = false;
      this.nearbyLogs = [];
      this.nearbyVehicles = [];
      this.nearbyInfoPosition = null;
      this.nearbyInfoLog = null;
      this.latlngInput = null;
      this.circleCenter = null;
      this.circleRadius = 0;
      this.nearbyTotal = 0;
      this.nearbyPage = 1;
      this.nearbyPerPage = 15;
      this.getLogs(this.page || 1);
    },

    handlePaginate(page) {
      if (this.nearbyFilterActive) this.getNearbyLogs(page); else this.getLogs(page);
    },

    applyFilters() {
      // Reset page and cache for new filter set
      this.page = 1;
      this.paginationKey++;
      this.logsCache = {};

      // If lat/lng provided, run nearby search using the same Filtrar button
      let baseLat = null;
      let baseLng = null;
      if (this.latlngInput && typeof this.latlngInput === 'string') {
        const parts = this.latlngInput.replace(/[()]/g, '').split(',').map(p => p.trim()).filter(Boolean);
        if (parts.length >= 2) {
          baseLat = parseFloat(parts[0]);
          baseLng = parseFloat(parts[1]);
        }
      }
      const radiusMeters = this.radiusUnit === 'km' ? (Number(this.radiusValue || 0) * 1000) : Number(this.radiusValue || 0);

      if (baseLat !== null && !isNaN(baseLat) && baseLng !== null && !isNaN(baseLng) && radiusMeters > 0) {
        // Trigger nearby search (will set circleCenter, circleRadius, nearbyFilterActive)
        this.getNearbyLogs(1);
      } else {
        // Normal logs search
        this.nearbyFilterActive = false;
        this.nearbyLogs = [];
        this.nearbyVehicles = [];
        this.getLogs(1);
      }
    },
  },
  mounted() { this.getLogs(); this.getUsers(); this.getVehicles(); },
};
</script>

<style scoped>
.color-success { color: green; }
.color-warning { color: rgb(212, 185, 62); }
.color-danger { color: red; }
.title { font-weight: bold; font-size: 1.2rem; }
.centered { text-align: center; }
</style>
